import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-add\"><path d=\"M768 512a35.84 35.84 0 0 1-35.84 35.84h-183.466667v182.613333a35.84 35.84 0 1 1-72.106666 0v-181.76H291.84a35.84 35.84 0 1 1 0-72.106666h184.32v-183.466667a35.84 35.84 0 1 1 72.106667 0v183.466667h183.466666A35.84 35.84 0 0 1 768 512zM512 0a512 512 0 1 0 512 512A512 512 0 0 0 512 0z\" fill=\"#1296db\" p-id=\"25726\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol